$('.langpicker').on('change', function() {
    window.location = $(this).val();
});


// WEBPACK FOOTER //
// ./js/global/langpicker.js